// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__E3vrN","validationTips":"StatementDescriptor_validationTips__1Vr9O"};